import { CustomerState, wrapStateWithCustomerNumber } from '../utils/url';
import { CustomerUser, CustomerUserAction, CustomerUserActions, DeleteSuccessCustomerUserPayload, FetchSuccessCustomerUserPayload } from '../model/customer-user';
import { ResponsePayload } from '../model/request';

import createReducer from './createReducer';

export const customerUsers = createReducer<CustomerState<CustomerUser[]>>({}, {
  [CustomerUserActions.FETCH_CUSTOMER_USERS_SUCCESS](
    state: CustomerState<CustomerUser[]>,
    action: CustomerUserAction
  ) {
    return wrapStateWithCustomerNumber((action.payload as ResponsePayload<FetchSuccessCustomerUserPayload>).data, state, []);
  },
  [CustomerUserActions.CREATE_CUSTOMER_USER_SUCCESS](
    state: CustomerState<CustomerUser[]>,
    action: CustomerUserAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      return [
        (action.payload as ResponsePayload<CustomerUser>).data,
        ...(oldState || [])
      ];
    }, state, [])
  },
  [CustomerUserActions.UPDATE_CUSTOMER_USER_SUCCESS](
    state: CustomerState<CustomerUser[]>,
    action: CustomerUserAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const { data } = action.payload as ResponsePayload<CustomerUser>;
      const userIndex = oldState.findIndex(s => s.id === data.id);

      if (userIndex < 0) {
        return oldState;
      }

      return [
        ...oldState.slice(0, userIndex),
        {
          ...oldState[userIndex],
          ...data,
        },
        ...oldState.slice(userIndex + 1)
      ]
    }, state, [])
  },
  [CustomerUserActions.DELETE_CUSTOMER_USER_SUCCESS](
    state: CustomerState<CustomerUser[]>,
    action: CustomerUserAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const userId = (action.payload as ResponsePayload<DeleteSuccessCustomerUserPayload>).data.id;
      const userIndex = oldState.findIndex(s => s.id === +userId);

      return [
        ...oldState.slice(0, userIndex),
        ...oldState.slice(userIndex + 1)
      ]
    }, state, [])
  },
});
